// extracted by mini-css-extract-plugin
export var text = "_bz-0";